import React from 'react';
import { Card } from '../ui/Card';
import { AlertCircleIcon, MoonIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-cream" data-id="element-198">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        {/* The Hook */}
        <div className="prose prose-lg mx-auto mb-20 text-center" data-id="element-200">
          <p className="font-heading text-2xl md:text-3xl leading-relaxed text-taupe mb-6" data-id="element-201">
            Te miras al espejo antes de una cena especial. Tienes ese pantalón
            que tanto te gusta, pero hay un problema:{' '}
            <span className="text-rose font-semibold" data-id="element-202">el botón no cierra.</span>
          </p>
          <p className="font-body text-lg text-taupe-light mb-6" data-id="element-203">
            No es por falta de voluntad, ni porque hayas comido de más esta
            semana. Es como si tu cuerpo hubiera decidido, de la noche a la
            mañana, que ya no sabe cómo procesar la comida.
          </p>
          <p className="font-body text-lg text-taupe-light mb-8" data-id="element-204">
            Lo intentas con fuerza, metes la tripa, pero la frustración te gana.
            Te preguntas:
          </p>
          <blockquote className="font-heading text-3xl italic text-gold border-none text-center px-0" data-id="element-205">
            "¿En qué momento mi cuerpo dejó de ser mi aliado?"
          </blockquote>
        </div>

        {/* The Specific Problem */}
        <div className="relative" data-id="element-206">
          <div className="absolute inset-0 bg-beige rounded-3xl transform -rotate-1" data-id="element-207"></div>
          <Card variant="elevated" className="relative p-8 md:p-12" data-id="element-208">
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-taupe mb-8 text-center" data-id="element-209">
              Después de la menopausia, las reglas del juego cambian.
            </h3>

            <div className="space-y-6 text-lg font-body text-taupe-light" data-id="element-210">
              <p data-id="element-211">
                Tus hormonas entran en un estado de{' '}
                <strong data-id="element-212">"alerta máxima"</strong>. Lo que antes funcionaba (comer
                menos, correr más) ahora solo empeora las cosas.
              </p>
              <p data-id="element-213">
                Al recortar calorías drásticamente, le dices a tu cerebro que
                hay una emergencia. ¿El resultado? Tu cuerpo dispara los niveles
                de cortisol (la hormona del estrés), bloqueando la quema de
                grasa abdominal y robándote el sueño profundo.
              </p>
              <div className="bg-rose/10 p-6 rounded-xl border border-rose/20 mt-8" data-id="element-214">
                <p className="font-heading text-xl text-taupe font-medium text-center m-0" data-id="element-215">
                  No estás estancada porque te falte disciplina;
                  <br data-id="element-216" />
                  estás estancada porque tu motor hormonal está en{' '}
                  <span className="text-rose font-bold" data-id="element-217">"modo pausa"</span>.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}